import type { CelebrityResult } from "./types";

export const mattForte: CelebrityResult = {
  slug: "matt-forte",
  firstName: "Matt",
  lastName: "Forte",
  roleLines: ["Professional Football Player (Retired)", "6,800 Grafts"],
  headlineLines: ["An All-Pro Running Back", "Wouldn't Let Hair Loss Take Him Down"],
  intro: [
    "Matt Forte spent ten years of his life on the football field as a running back. While he managed to avoid getting tackled, he was not as successful with avoiding hair loss. After years of thinning hair and finally shaving his head, Matt was ready to get rid of the stack of hats he had collected so he went to RESTORE® to explore his options of hair restoration.",
  ],
  heroBannerImage: {
    src: "/endorser-banners/forte_website_banner_1920x800_v1.webp",
    alt: "Matt Forte RESTORE hair restoration results banner",
  },
  heroBannerImageMobile: {
    src: "/endorser-banners/forte_website_mobile_800x879_v1.webp",
    alt: "Matt Forte RESTORE hair restoration results banner",
  },
  heroBackground: "/img/r/wp-2024-09-usa-today-9007628.webp",
  heroBackgroundPosition: "center top",
  heroLayout: "diagonal-right",
  heroMinHeight: "700px",
  posterImage: {
    src: "/img/r/wp-2024-09-restore-mattforte-after-72-5-1.webp",
    alt: "Matt Forte RESTORE Hair Results",
  },

  heroBeforeAfter: {
    src: "/img/r/wp-2024-09-mat-before.webp",
    alt: "Matt Forte before hair transplant",
  },
  story: {
    video:
      "https://d17ehmrb6zqtjv.cloudfront.net/Videos/Videos+with+Captions/MattForte%27sStoryRESTOREHair.mp4",
    headingSuffix: "Hair Transplant Journey",
    paragraphs: [
      "Matt Forte spent ten years of his life on the football field as a running back. While he managed to avoid getting tackled, he was not as successful with avoiding hair loss. After years of thinning hair and finally shaving his head, Matt was ready to get rid of the stack of hats he had collected so he went to RESTORE® to explore his options of hair restoration.",
      "Seeing results from Brian Urlacher, he knew RESTORE was a trusted Chicagoland name.",
      "\"When I saw the results from a teammate of mine, I was thinking that it's not for African American guys, but then saw other clients, who have the same type of hair that I have, got their hair back and it looked really good so I came in for a consultation.\"",
      "Thrilled with his results from RESTORE, he now wants to share the real reason he wanted the RESTORE experience.",
      "He revealed that being able to share the barbershop experience with his son was what inspired him.",
      "\"It's almost like a rite of passage for a kid, when they go to the barbershop with their dad. Some of the greatest conversations go on in the barbershop between men and their sons so it's fun now to be able to go into the barbershop and spend time with your son.\"",
    ],
    image: {
      src: "/img/r/wp-2022-09-matt-forte-video-1.webp",
      alt: "Matt Forte's Strong Hold: How a Hair Transplant Restored His Confidence and Game-Ready Look",
    },
  },
  qa: {
    heading: "Matt Forte Talks About His Unique Hair Type",
    items: [
      {
        image: {
          src: "/img/r/wp-2021-12-matt-forte-results-qa-01.webp",
          alt: "Matt Forte After Hair Transplant",
        },
        question: "How was your RESTORE experience?",
        answer:
          "It was really seamless, they explained how the procedure was done, how long the procedure would take, how long it would take to see results. They treated me with the utmost care.",
      },
      {
        image: {
          src: "/img/r/wp-2021-12-matt-forte-results-qa-02.webp",
          alt: "Matt Forte After Hair Transplant",
        },
        question: "What would you tell other guys who deal with hair loss?",
        answer:
          "Male pattern baldness happens to a lot of us and to have an organization like them to restore your hair and you can get that back, it's a dream come true.",
      },
      {
        image: {
          src: "/img/r/wp-2021-12-matt-forte-results-qa-03.webp",
          alt: "Matt Forte After Hair Transplant",
        },
        question: "What do you think the reaction from the public will be when they see your new hair?",
        answer:
          "I think they'll be impressed! I myself am impressed and I never would have thought that it would've turned out this well.",
      },
      {
        image: {
          src: "/img/r/wp-2021-12-matt-forte-results-qa-04.webp",
          alt: "Matt Forte After Hair Transplant",
        },
        question: "What have you done with the hats you used to wear?",
        answer:
          "They collect dust now, I haven't burned them yet, but I have to have a hat burning ceremony. I think every guy should have that!",
      },
    ],
  },
  seo: {
    title: "Matt Forte Hair Transplant Results | RESTORE® Hair",
    description:
      "See former NFL running back Matt Forte's RESTORE® No-Shave FUE™ hair transplant results, before & after photos and his full hair restoration story.",
  },
};
